import { Component} from '@angular/core';
import { IonApp, IonRouterOutlet } from '@ionic/angular/standalone';
import { AmplifyAuthenticatorModule } from '@aws-amplify/ui-angular';
// other imports here...
// import { RouterModule } from '@angular/router';
// import { BrowserModule } from '@angular/platform-browser';
import { TranslateService} from '@ngx-translate/core';
// import { TranslateService } from './services/translate.service';
// import { BrowserModule } from '@angular/platform-browser';
// import { CapitalizePipe } from './pipes/capitalize.pipe';
// import { TranslateService } from '@ngx-translate/core';
// import { CustomTranslateLoader } from './services/custom-translate-loader';
import { TranslateConfigModule } from './services/translate-config.module';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  standalone: true,
  imports: [IonApp, IonRouterOutlet,TranslateConfigModule, AmplifyAuthenticatorModule ],
  providers: [TranslateService],
})

export class AppComponent {

  constructor(private translate: TranslateService) {
    this.translate.addLangs(['en', 'ro' , 'de']);
    this.translate.setDefaultLang('ro');
    this.translate.use('ro');
    // console.warn('Missing translation');
  }

}
